import type React from 'react';
import { useEffect } from 'react';
import { getAdminUrl } from '@/utils/crossAppLinks';

/**
 * Public-site registration on the marketing pages is workspace-oriented
 * ("Free for performers. Venues start at $0/month."), but the multi-step
 * workspace onboarding wizard lives in the admin app. Sending users straight
 * to admin onboarding avoids creating stranded user accounts with no workspace
 * and removes the audience-vs-admin signup ambiguity.
 *
 * The route is preserved so existing links/bookmarks keep working.
 */
const Register: React.FC = () => {
  useEffect(() => {
    const dest = new URL(getAdminUrl('/register'));
    const incoming = new URLSearchParams(window.location.search);
    incoming.forEach((value, key) => {
      dest.searchParams.set(key, value);
    });
    window.location.replace(dest.toString());
  }, []);

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16">
      <p className="text-sm text-grey-500">Redirecting to sign up…</p>
    </div>
  );
};

export default Register;
